import { Button, Form, Input, InputNumber } from "antd";
import React, { useState } from "react";
import Layout from "../../../components/Layout";
import { request } from "../../../config/API";
import { COLORS } from "../../../config/theme";
import styles from "./AdminDetail.module.css";
import { openNotification } from "../../../redux/actions/Notification/notifications.action";
import { useHistory } from "react-router-dom";
import AlertModal from "./components/AlertModal";

const AdminDetail = () => {
  const history = useHistory();
  const { primaryDark } = COLORS;
  const [massCsv, setMassCsv] = useState("");
  const [adminId, setAdminId] = useState("");
  const [form] = Form.useForm();
  const form1 = form;
  const [isAdding, setIsAdding] = useState(false);
  const [singleCard, setSingleCard] = useState(null);

  const handleAddAdmin = (values) => {
    const formData = new FormData();
    const {
      fullName,
      email,
      fName,
      lName,
      mobile,
      jobTitle,
      company,
      address,
      website,
      password,
      confirmPassword,
      qrAllowed,
      linkName,
    } = values;
    formData.append("fullName", fullName);
    formData.append("email", email);

    fName && formData.append("fName", fName);
    lName && formData.append("lName", lName);
    mobile && formData.append("mobile", mobile);
    jobTitle && formData.append("jobTitle", jobTitle);
    company && formData.append("company", company);
    address && formData.append("address", address);
    website && formData.append("website", website);
    linkName && formData.append("linkName", linkName);

    formData.append("password", password);
    formData.append("confirmPassword", confirmPassword);
    formData.append("qrAllowed", qrAllowed);
    massCsv && formData.append("file", massCsv);

    setIsAdding(true);
    request
      .post("user/admin", formData)
      .then((data) => {
        setIsAdding(false);
        setMassCsv(null);
        let description = "User added successfully!";
        if (data?.data?.message) {
          description = `${description} , ${data?.data?.message}`;
        }
        openNotification({
          message: "Success",
          description,
          icon: "success",
        });
        history.push("/app/admins");
      })
      .catch((err) => {
        if (!err?.response?.data?.isAdmin) {
          const error = err?.response?.data?.data || "Something Happened";
          openNotification({
            message: "Error",
            description: error,
            icon: "error",
          });
        } else {
          setAdminId(err?.response?.data?.adminId);
          setSingleCard({
            fName,
            lName,
            mobile,
            jobTitle,
            company,
            address,
            website,
            linkName,
          });
        }
        setIsAdding(false);
      });
  };
  const handleAddAdminCards = () => {
    const formData = new FormData();
    const {
      fName,
      lName,
      mobile,
      jobTitle,
      company,
      address,
      website,
      linkName,
    } = singleCard;
    fName && formData.append("fName", fName);
    lName && formData.append("lName", lName);
    mobile && formData.append("mobile", mobile);
    jobTitle && formData.append("jobTitle", jobTitle);
    company && formData.append("company", company);
    address && formData.append("address", address);
    website && formData.append("website", website);
    linkName && formData.append("linkName", linkName);
    massCsv && formData.append("file", massCsv);
    setIsAdding(true);
    request
      .patch(`user/adminCards/${adminId}`, formData)
      .then((data) => {
        setIsAdding(false);
        setMassCsv(null);
        let description = "Cards added successfully!";
        if (data?.data?.message) {
          description = `${description} , ${data?.data?.message}`;
        }
        openNotification({
          message: "Success",
          description,
          icon: "success",
        });
        history.push("/app/admins");
      })
      .catch((err) => {
        console.log("err", err.response.data);
        const error = err?.response?.data?.data || "Something Happened";
        openNotification({
          message: "Error",
          description: error,
          icon: "error",
        });

        setIsAdding(false);
      });
  };

  return (
    <Layout heading="Add User">
      <Form
        form={form1}
        className={styles.addForm}
        labelCol={{ span: 7 }}
        labelAlign="left"
        onFinish={handleAddAdmin}
      >
        <div className={styles.addFormContainer}>
          <div className={styles.formCol} style={{ marginRight: "2rem" }}>
            <span
              style={{
                textAlign: "center",
                marginBottom: "1rem",
                fontWeight: "600",
                fontSize: "1rem",
              }}
            >
              ADMIN DETAIL
            </span>
            <Form.Item
              label="Enter Full Name"
              name="fullName"
              hasFeedback
              rules={[{ required: true, message: "This field is required" }]}
            >
              <Input size="large" />
            </Form.Item>
            <Form.Item
              label="Enter Email"
              name="email"
              hasFeedback
              rules={[
                { required: true, message: "This field is required" },
                { type: "email", message: "Please Enter Valid Email" },
              ]}
            >
              <Input size="large" />
            </Form.Item>
            <Form.Item
              label="Password"
              name="password"
              hasFeedback
              rules={[
                { required: true, message: "This field is required" },
                { min: 6, message: "Password should be atleast 6 characters" },
              ]}
            >
              <Input.Password size="large" />
            </Form.Item>
            <Form.Item
              label="Re-Password"
              name="confirmPassword"
              hasFeedback
              dependencies={["password"]}
              rules={[
                { required: true, message: "This field is required" },
                ({ getFieldValue }) => ({
                  validator(_, value) {
                    if (!value || getFieldValue("password") === value) {
                      return Promise.resolve();
                    }
                    return Promise.reject(
                      new Error(
                        "The two passwords that you entered do not match!"
                      )
                    );
                  },
                }),
              ]}
            >
              <Input.Password size="large" />
            </Form.Item>
            <Form.Item
              label="Cards Allowed"
              name="qrAllowed"
              hasFeedback
              rules={[{ required: true, message: "This field is required" }]}
            >
              <InputNumber
                style={{ width: "90%", borderRadius: 8 }}
                min={1}
                size="large"
              />
            </Form.Item>
          </div>
          <div className={styles.formCol}>
            <span
              style={{
                textAlign: "center",
                marginBottom: "1rem",
                fontWeight: "600",
                fontSize: "1rem",
              }}
            >
              WAVE CARD
            </span>
            <Form.Item
              label="First Name"
              name="fName"
              hasFeedback
              // rules={[{ required: true, message: "This field is required" }]}
            >
              <Input size="large" />
            </Form.Item>
            <Form.Item
              label="Last Name"
              name="lName"
              hasFeedback
              // rules={[{ required: true, message: "This field is required" }]}
            >
              <Input size="large" />
            </Form.Item>
            <Form.Item
              label="Enter Mobile"
              name="mobile"
              hasFeedback
              // rules={[{ required: true, message: "This field is required" }]}
            >
              <Input size="large" />
            </Form.Item>
            <Form.Item
              label="Enter Job Title"
              name="jobTitle"
              hasFeedback
              // rules={[{ required: true, message: "This field is required" }]}
            >
              <Input size="large" />
            </Form.Item>
            <Form.Item
              label="Enter Company"
              name="company"
              hasFeedback
              // rules={[{ required: true, message: "This field is required" }]}
            >
              <Input size="large" />
            </Form.Item>
            <Form.Item
              label="Enter Address"
              name="address"
              hasFeedback
              // rules={[{ required: true, message: "This field is required" }]}
            >
              <Input size="large" />
            </Form.Item>
            <Form.Item
              label="Enter Website"
              name="website"
              hasFeedback
              // rules={[{ required: true, message: "This field is required" }]}
            >
              <Input size="large" />
            </Form.Item>
            <Form.Item
              label="Enter Link Name"
              name="linkName"
              hasFeedback
              // rules={[{ required: true, message: "This field is required" }]}
            >
              <Input size="large" />
            </Form.Item>
            <div
              style={{
                display: "flex",
                justifyContent: "center",
                marginTop: "1rem",
                marginBottom: "1rem",
              }}
            >
              <span style={{ fontSize: "1rem", fontWeight: "500" }}>OR</span>
            </div>
            <Form.Item label="Mass Cards Setup">
              <div style={{ display: "flex" }}>
                <input
                  type="file"
                  id="uploadFile"
                  accept=".csv"
                  style={{ display: "none" }}
                  onChange={(event) => {
                    console.log("event", event);
                    const file = event.target.files[0];
                    console.log("file", file);
                    if (file.type !== "text/csv") {
                      console.log("Invalid File type!");
                      openNotification({
                        message: "Error",
                        description: "Only CSV Allowed",
                        icon: "error",
                      });
                      return;
                    }
                    setMassCsv(file);
                  }}
                  value={""}
                />
                {massCsv ? (
                  <div
                    style={{
                      background: primaryDark,
                      borderColor: primaryDark,
                      color: "white",
                      padding: ".5rem 1rem",
                      borderRadius: "2rem",
                      position: "relative",
                    }}
                  >
                    {/* <span>{massCsv?.name}</span> */}
                    <span>{"1 file uploaded"}</span>

                    <span
                      style={{
                        position: "absolute",
                        top: "-10%",
                        right: "-5%",
                        display: "flex",
                        padding: ".5rem .5rem",
                        borderRadius: "500px",
                        backgroundColor: "red",
                        cursor: "pointer",
                        lineHeight: "7px",
                      }}
                      onClick={(event) => {
                        event.stopPropagation();
                        setMassCsv();
                      }}
                    >
                      x
                    </span>
                  </div>
                ) : (
                  <label
                    style={{
                      cursor: "pointer",
                      background: primaryDark,
                      borderColor: primaryDark,
                      color: "white",
                      padding: ".5rem 1rem",
                      borderRadius: "2rem",
                    }}
                    htmlFor="uploadFile"
                  >
                    Upload CVS
                  </label>
                )}
              </div>
            </Form.Item>
          </div>
        </div>
        <div
          style={{
            display: "flex",
            justifyContent: "center",
            marginTop: "5rem",
          }}
        >
          <div
            style={{
              width: "20rem",
            }}
          >
            <Form.Item>
              <Button
                type="primary"
                shape="round"
                style={{
                  display: "flex",
                  background: primaryDark,
                  borderColor: primaryDark,
                  alignSelf: "center",
                  paddingLeft: "4rem",
                  paddingRight: "4rem",
                }}
                size="large"
                htmlType="submit"
                loading={isAdding}
              >
                Submit
              </Button>
            </Form.Item>
          </div>
        </div>
      </Form>
      <AlertModal
        adminId={adminId}
        setAdminId={setAdminId}
        handleAddAdminCards={handleAddAdminCards}
      />
    </Layout>
  );
};

export default AdminDetail;
